var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { connect } from 'react-redux';
import SeoTextForm from '../../components/SeoText/SeoTextForm/SeoTextForm';
import SeoTextReduxProps from './SeoTextReduxProps';
var SeoText = /** @class */ (function (_super) {
    __extends(SeoText, _super);
    function SeoText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SeoText.prototype.render = function () {
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn " },
                React.createElement("h1", { className: "display-3" }, "SEO \u0422\u0435\u043A\u0441\u0442 \u0437\u0430 \u041D\u0430\u0447\u0430\u043B\u043D\u0430\u0442\u0430 \u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-6" },
                        React.createElement(SeoTextForm, null))))));
    };
    return SeoText;
}(React.Component));
export default connect(null, SeoTextReduxProps.mapDispatchToProps)(SeoText);



//////////////////
// WEBPACK FOOTER
// ./src/views/SeoText/SeoText.tsx
// module id = 460
// module chunks = 0